import { Box, Fab, Grid, alpha, styled } from '@mui/material';
import { Card } from '@totalsoft/rocket-ui';
import InfoIcon from '@mui/icons-material/Info';
import ErrorIcon from '@mui/icons-material/Error';
import EditIcon from '@mui/icons-material/Edit';

export const WarningsAnchor = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(-10)
}));

export const WarningsWrapper = styled(Box, { shouldForwardProp: prop => prop !== 'empty' })(({ theme, empty }) => ({
  width: '100%',
  paddingInline: theme.spacing(1),
  paddingBlock: !empty ? theme.spacing(1) : 0,
  backgroundColor: alpha(theme.palette.warning.main, 0.1),
  borderRadius: theme.spacing(1),
  marginInline: theme.spacing(1),
  marginBlock: !empty ? theme.spacing(1) : 0
}));

export const WarningsContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(0.5),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: theme.palette.warning.main
}));

export const GoToWarningsFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  zIndex: 9999,
  right: theme.spacing(6),
  bottom: theme.spacing(10),
  boxShadow: theme.shadows[24]
}));

export const LoadingWrapper = styled(Box)(() => ({
  width: '100%'
}));

export const RenewalItemsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1)
}));

export const RenewalItemOfferLink = styled('a')(() => ({
  '&:hover': {
    textDecoration: 'underline'
  }
}));

export const RenewalItemWarning = styled('span')(({ theme }) => ({
  color: theme.palette.warning.main
}));

export const RenewalItemCommentContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  paddingLeft: theme.spacing(1),
  marginTop: theme.spacing(-0.5)
}));

export const RenewalItemAdditionalInfoButtonContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  color: theme.palette.error.main,
  top: 0,
  right: 0
}));

export const RenewalItemAdditionalInfoContainer = styled(Box)(({ theme }) => ({
  color: theme.palette.error.main,
  backgroundColor: alpha(theme.palette.error.main, 0.1),
  paddingBlock: theme.spacing(0.5),
  paddingInline: theme.spacing(1.5),
  borderRadius: theme.spacing(1),
  marginBottom: theme.spacing(2),
  marginInline: theme.spacing(-1)
}));

export const RenewalQuotationInsurerName = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
}));

export const RenewalQuotationCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  width: '100%'
}));

export const RenewalQuotationInsurerPeriodTitle = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  textTransform: 'uppercase',
  fontSize: '16px',
  marginLeft: theme.spacing(1)
}));

export const RenewalQuotationAmountContainer = styled(Grid)(() => ({
  lineHeight: 1,
  height: '30px'
}));

export const RenewalQuotationAmount = styled('span')(() => ({
  whiteSpace: 'nowrap'
}));

export const RenewalQuotationInfoIcon = styled(InfoIcon)(({ theme }) => ({
  color: theme.palette.success.main,
  cursor: 'pointer'
}));

export const RenewalQuotationErrorIcon = styled(ErrorIcon)(({ theme }) => ({
  color: theme.palette.error.main,
  cursor: 'pointer'
}));

export const RenewalQuotationEditIcon = styled(EditIcon)(() => ({
  cursor: 'pointer',
  fontSize: '18px'
}));
